import React, { useEffect, useState ,useMemo} from 'react';
import $ from 'jquery';
import { useNavigate, NavLink } from 'react-router-dom';
import { FormGroup, Label, Form, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import moment from 'moment';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';
import FileViewer from './FileView';
import { parseValue } from '../utils/Common';
import Table from './common/Table';


const common = require('../utils/Common');
const envConfig = require('../config/envConfig');

const Sellers = () => {
    let navigate = useNavigate();
    const [modal, setModal] = useState(false);
    const [paymentOrders, setPaymentOrders] = useState([]);
    const [finalPaymentOrders, setFinalPaymentOrders] = useState([]);
    const [paymentForSeller, setPaymentForSeller] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [showModalgst, setshowModalgst] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
    const [totalRecords, setTotalRecords] = useState(0);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});

    const toggle = (orders = []) => {
        setModal(!modal);
        let finalPaymentOrders = [];
        orders.map((order) => {
            let orderItemIds = [];
            let paymentAmount = 0;
            let delivered = 0;
            order.order_items.map((data) => {
                if (data.order_status == 'delivered' && !data.seller_payment_status) {
                    if (paymentForSeller == 0) {
                        setPaymentForSeller(data.seller_id)
                    }
                    delivered = 1;
                    orderItemIds.push(data.id);
                    paymentAmount += parseInt(data.net_payment);
                }
            })
            if (delivered) {
                finalPaymentOrders.push({
                    orderId: order.id,
                    orderNo: order.order_id,
                    orderItemIds: orderItemIds.join(','),
                    paymentAmount: paymentAmount
                })
            }
        })
        setPaymentOrders(finalPaymentOrders);
        if (finalPaymentOrders.length == 0 && !modal) {
            alert('Nothing to pay');
            setModal(modal);
        }
    }
    const [sellersData, setSellersData] = useState([]);
	const getSellers = async (limit = 10, offset = 0, search = {}) => {
        const currentStartDate = $('#Date-from').val() || startDate;
        const currentEndDate = $('#Date-to').val() || endDate;

        setStartDate(currentStartDate);
        setEndDate(currentEndDate);
		let data = {
			"user_type" : 'seller',
            'fromDate': currentStartDate,
            'toDate': currentEndDate,
            'limit': limit,
            'offset': offset
		}
		let response = await common.apiRequest('post', '/admin/get-sellers-users-data', data);
		if (response.status == 200) {
			if (response.data.code == 'success') {
                setSellersData(response.data.data);
                setTotalRecords(response.data.totalRecords);
			} else {
                alert(response.data.error);
            }
		} else {
            alert(response.data.error);
		}
	}   
    const handleDateChange = (e) => {
        if (e.target.id === "Date-from") {
          setStartDate(e.target.value);
        } else if (e.target.id === "Date-to") {
          setEndDate(e.target.value);
        }
        getSellers();
      };

      const movePage = (path, sellerId, rowType = null) => {
        const startDateValue = $('#Date-from').val() || startDate;
        const endDateValue = $('#Date-to').val() || endDate;
              
        navigate(path, { 
            state: {
                sellerId: sellerId,
                startDate: startDateValue,
                endDate: endDateValue,
                rowType: rowType // Make sure this is properly passed
            }
        });
    }

    const setTdsCommission = async (id, seller_id) => {
        let value = $('#'+id).val();
        let data = {
            'update': id,
            'value': value,
            'seller_id': seller_id
        }
        let response = await common.apiRequest('post', '/admin/update-seller-tds-commission', data);
		if (response.status == 200) {
			if (response.data.code == 'success') {
                alert(response.data.message);
			} else {
                alert(response.data.error);
            }
		} else {
            alert(response.data.error);
		}
    }

    const addPayment = async (order, e) => {
        let finalPayment = finalPaymentOrders;
        if (e.target.checked) {
            finalPayment.push(order);
        } else {
            finalPayment = finalPayment.filter(function( obj ) {
                return obj.orderId !== order.orderId;
            });
        }
        setFinalPaymentOrders(finalPayment);
    }

    const makePayment = async (sellerId) => {
        if (finalPaymentOrders == 0) {
            alert("Please select one order");
            return;
        }
        let paymentAmount = 0;
        let orderItemIds = "";
        finalPaymentOrders.map((payment) => {
            orderItemIds = (orderItemIds == "" ? payment.orderItemIds : (orderItemIds + "," + payment.orderItemIds));
            paymentAmount += parseInt(payment.paymentAmount);
        })
        let data = {
            'action': 'create',
            'seller_id': sellerId,
            'order_item_ids': orderItemIds,
            'order_payment_amount': paymentAmount,
            'payment_status': 'done'
        }
        let response = await common.apiRequest('post', '/seller/crud-seller-payments', data);
		if (response.status == 200) {
			if (response.data.code == 'success') {
                alert(response.data.message);
                window.location.href = "/sellers";
			} else {
                alert(response.data.error);
            }
		} else {
            alert(response.data.error);
		}
    }

	useEffect(() => {
        checkAccess();
	}, []);
    const handleShowModal = (user) => {
        setSelectedUser(user);
        setShowModal(true);
      };
      const handleShowModalGst = (user) => {
        setSelectedUser(user);
        setshowModalgst(true);
      };
    
      const handleCloseModal = () => {
        setShowModal(false);
        setshowModalgst(false);
        setSelectedUser(null);
      };
    const checkAccess = async () => {
        let rights = await common.checkAccessRights(window.location.pathname);
        if (!rights.view) {
          alert("Access Denied");
          navigate("/");
          return;
        } else {
            setUserRights(rights);
            if (!localStorage.getItem('admin_token')) {
                navigate('/login');
            }
            getSellers();
        }
      }

      const handleAccept = async (id) => {
        const data = {
            action: "update",
            id: id,
            pan_status: "1",
            user_type: 'seller'
        };
        try {
            let response = await common.apiRequest('post', '/admin/crud-pan-status', data);
            if (response.data.code === "success") {
                alert(response.data.message);
                getSellers();
            } else {
                alert(response.data.error);
            }
        } catch (error) {
            console.error('Error updating data:', error);
        }
        handleCloseModal();
    };
    
      const handleReject = async(id) => {
        const data = {
            action: "update",
            id:id,
            pan_status: "2",
            user_type : 'seller'
          };
          try {
            let response = await common.apiRequest('post', '/admin/crud-pan-status', data);
            if (response.data.code === "success") {
                alert(response.data.message);
                getSellers();
            } else {
              alert(response.data.error);
            }
          } catch (error) {
            console.error('Error fetching data:', error);
          }    handleCloseModal();
      };
     const columns = [
    { accessor: 'reg_id', header: 'User Id' },
    { accessor: 'first_name', header: 'First Name' },
    { accessor: 'middle_name', header: 'Middle Name' },
    { accessor: 'last_name', header: 'Last Name' },
    { accessor: 'seller_business_name', header: 'Service Vendor Business Name' },
    { accessor: 'seller_pan_no', header: 'PAN No' },
    { accessor: 'seller_gst', header: 'GST No' },
    {
        accessor: 'totalPurchases',
        header: 'Total Purchases',
        render: (row) => parseValue(Number(row.totalPurchases) || 0, 'float')
    },
    {
        accessor: 'totalSales',
        header: 'Total Sales',
        render: (row) => parseValue(Number(row.totalSales) || 0, 'float')
    },
    { accessor: 'seller_email', header: 'Email' },
    { accessor: 'mobile_phone', header: 'Mobile Phone' },
    { accessor: 'seller_bank_account_no', header: 'Bank Account No' },
    { accessor: 'seller_bank', header: 'Bank Name' },
    { accessor: 'seller_ifsc_code', header: 'IFSC Code' },
    { accessor: 'seller_nominee_name', header: 'Nominee Name' },
    { accessor: 'referrerBY', header: 'Referred By' },
    { accessor: 'user_address', header: 'Address' },
    { accessor: 'seller_Point_Contact', header: 'Point of Contact' },
    {
        accessor: 'tds',
        header: 'TDS',
        render: (row) => (
        <div>
            <input
            type="text"
            id="tds"
            defaultValue={row.seller_tds}
            placeholder="Enter TDS"
            style={{ width: '100px', marginRight: '5px' }}
            />
            <Button color="primary" size="sm" onClick={() => setTdsCommission('tds', row.id)}>
            Save
            </Button>
        </div>
        )
    },
    {
        accessor: 'commission',
        header: 'Commission',
        render: (row) => (
        <div>
            <input
            type="text"
            id="commission"
            defaultValue={row.seller_commission}
            placeholder="Enter Commission"
            style={{ width: '100px', marginRight: '5px' }}
            />
            <Button color="primary" size="sm" onClick={() => setTdsCommission('commission', row.id)}>
            Save
            </Button>
        </div>
        )
    },
    {
        accessor: 'orders',
        header: 'Orders',
        render: (row) => (
        <center>
            <div>
            <Button color="primary" size="sm" onClick={() => movePage('/sellers-buyers-orders', row.id)}>
                All Orders
            </Button>
            </div>
            <div>
            <Button color="primary" size="sm" onClick={() => movePage('/seller-logistics-orders', row.id)}>
                All Logistics Orders
            </Button>
            </div>
        </center>
        )
    },
    {
        accessor: 'products',
        header: 'Products',
        render: (row) => (
        <center>
            <Button color="primary" size="sm" onClick={() => movePage('/sellers-products', row.id)}>
            All Products
            </Button>
        </center>
        )
    },
    {
        accessor: 'services',
        header: 'Services',
        render: (row) => (
        <center>
            <Button color="primary" size="sm" onClick={() => movePage('/seller-service-approve', row.id, 'normal')}>
            Service
            </Button>
        </center>
        )
    },
    {
        accessor: 'Logistics_Service',
        header: 'Logistics Service',
        render: (row) => (
        <center>
            <Button color="primary" size="sm" onClick={() => movePage('/seller-service-approve', row.id, 'logistics')}>
            Logistics Service
            </Button>
        </center>
        )
    },
    {
        accessor: 'pan_image',
        header: 'Pan Image',
        render: (row) => (
        <Button color="primary" onClick={() => handleShowModal(row)}>
            View Image
        </Button>
        )
    },
    {
        accessor: 'seller_gst_certificate',
        header: 'User GST Certificate',
        render: (row) => (
        <Button color="primary" onClick={() => handleShowModalGst(row)}>
            View GST Image
        </Button>
        )
    },
    {
        accessor: 'is_hot_business',
        header: 'Hot Business',
        render: (row) => <HotProductDropdown data={row} />
    }
    ];


    const data = sellersData.map((item, index) => ({
        "S.no": index + 1,
        "User Id": item.reg_id || "N/A",  
        "First Name": item.first_name || "N/A",  
        "Middle Name": item.middle_name || "N/A",
        "Last Name": item.last_name || "N/A",  
        "Service Vendor Business Name": item.seller_business_name || "N/A",  
        "PAN No": item.seller_pan_no || "N/A",  
        "GST No": item.seller_gst || "N/A",  
        "Total Shopping Amount": item.totalPurchases || 0,  
        "Total Sales Amount": item.totalSales || 0,  
        "Email": item.email || "N/A",  
        "Mobile Phone": item.mobile_phone || "N/A",  
        "Bank Account No": item.bank_account_no || "N/A",  
        "Bank Name": item.bank_name || "N/A",  
        "IFSC Code": item.ifsc_code || "N/A",  
        "Nominee Name": item.nominee_name || "N/A",  
        "Referred By": item.referrerBY || "N/A",  
        "Address": item.user_address || "N/A",  
        "Point of Contact": item.seller_Point_Contact || "N/A",  
    }));


const handleExportCSV = () => {
    exportToCSV(data, 'All Sellers');
}

const handleExportExcel = () => {
    exportToExcel(data, 'All Sellers');
}

const handleExportPDF = () => {
    exportToPDF(data, 'All Sellers');
}

const HotProductDropdown = ({ data }) => {
    const id = data.id;
    const currentValue = data.seller_is_hot_business == 1 ? "Yes" : "No";

    const handleChange = (e) => {
        const value = e.target.value;
        setUnsetHotProduct(id, value);
    };

    return (
        <select
            className="form-select form-select-sm"
            onChange={handleChange}
            value={currentValue} // controlled component
        >
            <option value="Yes">Yes</option>
            <option value="No">No</option>
        </select>
    );
};

const setUnsetHotProduct = async (id, value) => {
    let data = {
        'id': id,
        'value': value,
        'source': "seller"
    }
    let response = await common.apiRequest('post', '/admin/set-unset-hot-product', data);
    if (response.data.code == 'success') {
        alert(response.data.message);
        getSellers();

    } else {
        alert(response.data.error);
    }
}
    return (
        <>
        <h1>All Sellers</h1><br/>
        <div className="col-md-12">
                        <Form className='row'>
                            <FormGroup className='col-md-4 row'>
                                <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
                                <Input type='date' value={startDate}
                            onChange={handleDateChange} className="form-control col-md-5" id="Date-from" name="Date-from"></Input>
                            </FormGroup>
                            <FormGroup className='col-md-4 row'>
                                <Label className="col-md-2 col-form-label" for="Date-to">To:</Label>
                                <Input type='date' value={endDate}
                            onChange={handleDateChange} className="form-control col-md-5" id="Date-to" name="Date-to"></Input>
                            </FormGroup>
                        </Form>
                        <button className='btn button-product' onClick={handleExportCSV}>Export to CSV</button>
                        <button className='btn button-product' onClick={handleExportExcel}>Export to Excel</button>
                        <button className='btn button-product' onClick={handleExportPDF}>Export to PDF</button>
                    </div>
        <div className="ag-theme-quartz" style={{ height: 600, width: '100%' }}>
                <Table
                    columns={columns}
                    data={sellersData}
                    totalRecords={totalRecords}
                    pageSize={10}
                    onPageChange = {getSellers}
                />
        </div>
        <Modal isOpen={modal} toggle={() => toggle([])} size="lg">
            <ModalHeader toggle={() => {toggle([])}}>Make Payment</ModalHeader>
            <ModalBody>
                {
                    paymentOrders.map((order) => {
                        return (
                            <>
                            <input type='checkbox' onClick={(e) => addPayment(order, e)}/>&nbsp;&nbsp;
                            <label>{order.orderNo} (Amount Rs - {order.paymentAmount})</label>
                            <br/>
                            </>
                        )
                    })
                }
                <Button className="mt-3" color='primary' size='sm' onClick={() => makePayment(paymentForSeller)}>Pay</Button>
            </ModalBody>
        </Modal>
        <Modal isOpen={showModal} toggle={handleCloseModal}>
                <ModalHeader toggle={handleCloseModal}>User PAN Image</ModalHeader>
                <ModalBody>
                     {selectedUser && (
                        <FileViewer  
                            fileUrl={envConfig.api_url + (selectedUser.seller_pan || '')}
                            fileType={selectedUser.seller_pan?.toLowerCase().endsWith('.pdf') ? 'pdf' : 'image'}
                        />
                    )}
                </ModalBody>
                <ModalFooter className="d-flex justify-content-center">
                    {selectedUser?.seller_pan_status == '0' ? (
                    <div className="d-flex gap-2">
                        <Button color="success" onClick={() => handleAccept(selectedUser.id)}>
                        Accept
                        </Button>
                        <Button color="danger" onClick={() => handleReject(selectedUser.id)}>
                        Reject
                        </Button>
                    </div>
                    ) : selectedUser?.seller_pan_status == '1' ? (
                    <span className="text-success font-weight-bold">Accepted</span>
                    ) : selectedUser?.seller_pan_status == '2' ? (
                    <span className="text-danger font-weight-bold">PAN Rejected</span>
                    ) : null}
                </ModalFooter>
        </Modal>
        <Modal isOpen={showModalgst} toggle={handleCloseModal}>
                <ModalHeader toggle={handleCloseModal}>User GST Image</ModalHeader>
                <ModalBody>
                     {selectedUser && (
                        <FileViewer 
                            fileUrl={envConfig.api_url + (selectedUser.seller_gst_certificate || '')}
                            fileType={selectedUser.seller_gst_certificate?.toLowerCase().endsWith('.pdf') ? 'pdf' : 'image'}
                        />
                        )}
                </ModalBody>
        </Modal>
        </>
    )
}

export default Sellers;